// extracted by mini-css-extract-plugin
export default {"cadastroPg":"styles_cadastroPg__vMAn5"};